<template>
  <div class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-md-3 col-11">
          <q-input
            filled
            v-model="queryForm['user.phoneNumber']"
            label="手机号"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-input
            filled
            v-model="queryForm['user.nickName']"
            label="用户昵称"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="意见和反馈"
      :data="tableData.list"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      binary-state-sort
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:body-cell-avatarUrl="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-img
              :src="props.row.user.avatarUrl"
              spinner-color="white"
              style="height: 45px; max-width: 45px"
            />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="search"
              @click="detail(props.row)"
            >
              <q-tooltip> 查看 </q-tooltip>
            </q-btn>
            <q-btn
              round
              color="deep-orange"
              size="xs"
              icon="delete_forever"
              @click="remove(props.row)"
            >
              <q-tooltip> 删除 </q-tooltip>
            </q-btn>
          </div>
        </q-td>
      </template>
    </q-table>

    <q-dialog v-model="visible">
      <q-card style="max-height: 60vh; width: 600px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">意见和反馈</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="scroll" style="max-height: 60vh">
          <div class="q-gutter-y-md column">
            <q-input
              filled
              v-model="suggestion.user.nickName"
              label="用户昵称"
              dense
              disable
            />
            <q-input
              filled
              v-model="suggestion.user.phoneNumber"
              label="手机号"
              dense
              disable
            />
            <q-input
              type="textarea"
              filled
              v-model="suggestion.content"
              label="反馈内容"
              dense
              clearable
            />
            <q-select
              outlined
              v-model="suggestion.status"
              :options="[
                { value: 0, label: '未处理' },
                { value: 1, label: '已处理' },
              ]"
              emit-value
              map-options
              label="状态"
              dense
              disable
            />
            <q-input
              type="textarea"
              filled
              v-model="suggestion.remark"
              label="备注"
              dense
              clearable
            />
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn flat label="标记为已处理" color="primary" @click="deal" />
          <q-btn flat label="关闭" color="primary" @click="visible = false" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { list, remove, deal } from "@/api/mp/suggestion";
export default {
  data() {
    return {
      visible: false,
      suggestion: { user: {} },
      queryForm: {},
      tableData: {},
      loading: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "userId",
          align: "center",
          label: "用户ID",
          field: "userId",
        },
        {
          name: "nickName",
          align: "center",
          label: "用户昵称",
          field: (row) => row.user.nickName,
        },
        {
          name: "avatarUrl",
          align: "center",
          label: "用户头像",
          field: (row) => row.user.avatarUrl,
        },
        {
          name: "phoneNumber",
          align: "center",
          label: "手机号",
          field: (row) => row.user.phoneNumber,
        },
        {
          name: "content",
          align: "center",
          label: "意见反馈",
          field: "content",
        },
        {
          name: "status",
          align: "center",
          label: "状态",
          field: (row) => (row.status == 0 ? "未处理" : "已处理"),
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },

  methods: {
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    detail(row) {
      this.suggestion = JSON.parse(JSON.stringify(row));
      this.visible = true;
    },
    remove(row) {
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "是否确认删除此条反馈意见?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          var self = this;
          remove(row.id).then(() => {
            self.$q.notify({ type: "positive", message: "删除成功" });
            self.query();
          });
        })
        .onCancel(() => {})
        .onDismiss(() => {});
    },
    deal() {
      deal(this.suggestion).then(() => {
        this.$q.notify({ type: "positive", message: "处理成功" });
        this.visible = false;
        this.query();
      });
    },
  },

  mounted() {
    this.query();
  },
};
</script>

<style scoped>
#queryForm {
  margin: 50px 0;
}
</style>